/**
 * Compact tax-form name for space-constrained chrome (the wizard rail, tabs):
 * catalog titles follow `<Jurisdiction> Form <ID> — <official descriptor>`
 * (e.g. "Federal Form W-4 — Employee's Withholding Certificate"), and the
 * design shows the jurisdiction + ID ("Federal W-4") in the rail while the
 * full title stays on the form-overview card. Falls back to the input when
 * the pattern doesn't match, so non-catalog titles pass through unchanged.
 */
export const selectorShortFormTitle = (
  title: string | undefined
): string | undefined => {
  if (!title) return undefined;
  const head = title.split("—")[0]?.trim();
  if (!head) return title;
  const short = head.replace(/\bForm\s+/i, "").trim();
  return short || head;
};
